import Checkbox from './checkbox'
import Collapsible from './collapsible'


const Section = ({ title, filters, searchGroup }) => {
   const items = filters.filter(({ count }) => count !== 0)/////////////// ----------------------------- ATTN

   return (
      <section>
         <p className='filters__title'>{title}</p>

         {items.length > 6 ? (
            <Collapsible filters={items} searchGroup={searchGroup} />
         ) : (
            items.map((data) => <Checkbox key={data.id} {...data} searchGroup={searchGroup} />)
         )}
      </section>
   )
}

export default Section
